window.log = console.log.bind(console)

Object.assign global,
  _with: (val, fn) ->
    # test for Promise
    if Promise.resolve(val) is val
      val.then (actualVal) ->
        fn.call(actualVal, actualVal) if actualVal?
    else
      fn.call(val, val) if val?

  _when: (check, cb, ms = 30) ->
    while true
      res = check()
      if res?
        cb?.call(res, res)
        return res
      await Promise.delay(ms)


global._ = global._it = new Proxy {},
  get: (_, prop) ->
    retrieve = (props...) ->
      fn = (obj) ->
        props.reduce ((obj, prop) -> obj[prop]), obj

      if props.last() in ['is', 'isnt']
        prop = props.pop()
        switch prop
          when 'is' then (val) -> (obj) -> fn(obj) is val
          when 'isnt' then (val) -> (obj) -> fn(obj) isnt val
      else
        new Proxy fn,
          get: (_, prop) -> retrieve(props..., prop)
    retrieve(prop)


Array::where = (query) ->
  @filter (e) ->
    not Object.entries(query).find ([ key, val ]) ->
      e?[key] isnt val


Array::whereFirst = (query) ->
  @find (e) ->
    not Object.entries(query).find ([ key, val ]) ->
      e?[key] isnt val


Array::last = ->
  @[@length - 1]


`function jsf32(a, b, c, d) {
    return function() {
        a |= 0; b |= 0; c |= 0; d |= 0;
        var t = a - (b << 27 | b >>> 5) | 0;
        a = b ^ (c << 17 | c >>> 15);
        b = c + d | 0;
        c = d + t | 0;
        d = a + t | 0;
        return (d >>> 0) / 4294967296;
    }
}`


_rand = jsf32(0xF1EA5EED, 1337, 1337, 1337, 1337)


Math.round2 = (number, places = 0) ->
  mul = 10 ** places
  Math.round(number * mul) / mul


Math.sum = (items) ->
  items.reduce ((s, i) -> s + i), 0


Math.average = (items) ->
  Math.sum(items) / items.length


Math.randomBetween = (min, max) ->
  _rand() * (max - min) + min


Math.randomIntBetween = (min, max) ->
  Math.floor(_rand() * (max - min + 1)) + min


Math.fastRandom = _rand


Promise.delay ?= (ms) ->
  new Promise (resolve) ->
    setTimeout resolve, ms


Array::pickRandom = ->
  this[Math.randomIntBetween(0, @length - 1)]